import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Constants } from '@app/shared-module/constants';
import { CommonService } from '@app/shared-module/common-service.service';
import { DrugRequest } from '@app/shared-module/models';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  constructor(
    private httpClient: HttpClient,
    private commonService: CommonService
  ) { }

  getDrugList(clinicID: string, drugType: string, pageNumber: number = 0, itemPerPage: number = 10, search: string = '') {
    const params = new HttpParams()
      .set(Constants.ITEMS_PER_PAGE, itemPerPage.toString())
      .set(Constants.PAGE_NUMBER, pageNumber.toString())
      .set(Constants.LABEL_SEARCH, search);
    return this.httpClient.get(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API +
      this.commonService.internalLoginValue._id + Constants.CLINIC_API + clinicID + Constants.DRUGS_API +
      drugType, { params }
    );
  }

  updateDrugItem(supplier: string, name: string, drugId: string, manufacturer: string, instructions: string) {
    const payload = {
      name, manufacturer, instructions, supplier
    };
    return this.httpClient.put(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API + this.commonService.internalLoginValue._id
      + Constants.DRUG_LIST_API_DASH + drugId, payload);
  }

  updateBatchItem(clinicId: string, rack_no: string, selling_price: number, drugId: string, batchId: string) {
    const payload = {
      rack_no, selling_price
    };
    return this.httpClient.put(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API + this.commonService.internalLoginValue._id
      + Constants.CLINIC_API + clinicId + Constants.SLASH_DRUG_SLASH_API + drugId + Constants.SLASH_BATCH_SLASH_API + batchId, payload);
  }

  getBatchList(clinicID: string, drugId: string, pageNumber: number = 0, itemPerPage: number = 10) {
    const params = new HttpParams()
      .set(Constants.ITEMS_PER_PAGE, itemPerPage.toString())
      .set(Constants.PAGE_NUMBER, pageNumber.toString());
    return this.httpClient.get(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API + this.commonService.internalLoginValue._id + Constants.CLINIC_API
      + clinicID + Constants.SLASH_DRUG_SLASH_API + drugId + Constants.SLASH_BATCHES_API, { params });
  }

  deleteDrugItem(drugId: string) {
    return this.httpClient.delete(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API +
      this.commonService.internalLoginValue._id + Constants.DRUG_LIST_API_DASH
      + drugId);
  }

  createBatch(clinicID: string, item: DrugRequest) {
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API + this.commonService.internalLoginValue._id
      + Constants.CLINIC_API + clinicID + Constants.SLASH_DRUG_SLASH_API + item.drugId + Constants.SLASH_BATCH_API, item);
  }

  consumeDrug(clinicID: string, qty: number, itemId: string) {
    const payLoad = {
      qty: qty.toString()
    };
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.DRUG_LIST_API + this.commonService.internalLoginValue._id
      + Constants.CLINIC_API + clinicID + Constants.SLASH_DRUG_SLASH_API + itemId + Constants.CONSUME_API, payLoad);
  }

  deleteBatchItem(clinicID: string, batchId: string, drugId: string) {
    return this.httpClient.delete(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API + this.commonService.internalLoginValue._id
      + Constants.CLINIC_API + clinicID + Constants.SLASH_DRUG_SLASH_API + drugId
      + Constants.SLASH_BATCH_SLASH_API + batchId);
  }

  createDrug(item: DrugRequest) {
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API +
      this.commonService.internalLoginValue._id + Constants.CREATE_DRUG_API, item);
  }

  UpdateDrugThreshold(clinicID: string, item: any) {
    return this.httpClient.patch(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API +
      this.commonService.internalLoginValue._id + Constants.DRUGS_API + clinicID, item);
  }

  // /internalUser/5ece9731377ae932f3306fe1/drug/uploadDrugList/5ece9e631f548034351fab38/5ece9e631f548034351fab37
  bulkUpload(files: File[]) {
    const formData: FormData = new FormData();
    for (const file of files) {
      formData.append('drugFile', file);
    }
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API +
      this.commonService.internalLoginValue._id + Constants.URL_DASH + Constants.DRUG_BULK_UPLOAD_API
      , formData);
  }

  getClinicList() {
    return this.httpClient.get(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API +
      this.commonService.internalLoginValue._id + Constants.CLINICS_API);
  }

  updateThreshold(threshold_qty: number, drugId: string) {
    return this.httpClient.patch(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API +
      this.commonService.internalLoginValue._id
      + Constants.DRUG_API + drugId, { threshold_qty });
  }

}
